import { QuoteCountries, QuoteFormStop } from '../types';
import { parseLocation } from './location';

/**
 * Aligns per-stop city/state/zip/country with the location string before quote submission.
 * When `location` parses, parsed components win so stale AI suggestion fields are not sent.
 */
export function normalizeStopsForQuickQuoteSubmission(
  stops: QuoteFormStop[]
): QuoteFormStop[] {
  return stops.map((stop) => {
    if (hasValidStructuredLocation(stop)) {
      return {
        ...stop,
        country: stop.country || QuoteCountries.USA,
      };
    }

    const parsedLocation = parseLocation(stop.location || '');
    if (parsedLocation) {
      return {
        ...stop,
        zip: parsedLocation.zip,
        city: parsedLocation.city,
        state: parsedLocation.state,
        country: parsedLocation.country || QuoteCountries.USA,
      };
    }

    return {
      ...stop,
      zip: stop.zip || '',
      city: stop.city || '',
      state: stop.state || '',
      country: stop.country || QuoteCountries.USA,
    };
  });
}

export function hasValidStructuredLocation(stop: QuoteFormStop): boolean {
  return Boolean(
    typeof stop.placeId === 'number' &&
    Number.isInteger(stop.placeId) &&
    stop.placeId > 0 &&
    stop.location?.trim() &&
    stop.location?.trim() === stop.locationDisplay?.trim() &&
    stop.city?.trim() &&
    stop.state?.trim() &&
    stop.country
  );
}
